<script>

import Vue from "vue";
import $ from "jquery";
import draggable from 'vuedraggable';
import Block from './components/Block.vue';
import Spacer from './components/Spacer.vue';
import Container from './components/Container.vue';
import Columns from './components/Columns.vue';
import ComponentMixin from './components/Component.vue';
import Preview from './components/Preview.vue';
import DateTimePicker from './components/DateTimePicker.vue';
import defaultComponents from './DefaultComponents.vue'


export default {
    name: 'App',
    components: {'draggable': draggable, 'block': Block, 'container': Container, 'columns': Columns, 'spacer': Spacer, 'preview': Preview, 'datetime-picker': DateTimePicker},
    data: function() {
        return {
            componentsAvailable: defaultComponents,
            componentChanged: false,
            componentsRegistered: [],
            components: [],
            hasUnsubscribe: false,
            styleWriter: null,
            idCounter: 300,
            templates: [],
            template: null,
            palette: null,
            emoji: [],
            css: null,
            colors: [],
            siteId: null,
            action: null,
            confirmed: false,
            wrapper: '',
            tab: 'specific',
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            name: '',
            html: '',
            templateSetDropdown: false,
            templateSets: [],
            templateSet: '',
            templateSetName: '',
            templateSetChanged: false, 
            templateTags: [],
            locked: true,
            editorActive: false,
            draggedType: false,
            draggedId: null,
            undoHistory: [],
            undoIndex: 0,
            editorSettings: {
                showDragged: {
                    label: 'Показывать перемещаемый объект',
                    value: false,
                }
            }, 
            componentRefs: {},
        } 
    },
    watch: {
        editorSettings: {
            handler: function(newValue) {
                localStorage.setItem('editorSettings', JSON.stringify(this.editorSettings));
            },
            deep: true
        }
    },
    mounted: function() {
        let template = null;
        this.styleWriter = document.createElement("style");
        document.body.appendChild(this.styleWriter);

        this.templates = JSON.parse(this.$root.$el.dataset.templates);
        this.templateSets = JSON.parse(this.$root.$el.dataset.template_sets);
        this.templateTags = JSON.parse(this.$root.$el.dataset.template_tags);

        if(this.$refs.data.dataset.value){ 
            let dataset = JSON.parse(this.$refs.data.dataset.value);
            this.components = dataset['components'];
            this.idCounter = dataset['idCounter'];
        }

        this.template = this.$refs.template_id.dataset.value;
        this.siteId = this.$el.dataset.site_id;

        this.utm_source = this.$el.dataset.utm_source;
        this.utm_medium = this.$el.dataset.utm_medium;
        this.utm_campaign = this.$el.dataset.utm_campaign;
        this.baseUrl = this.$el.dataset.base_url;

        if (this.templates.length) {
            if (!this.template) {
                this.template = this.templates[0]['id'];
            }
            if(this.$el.dataset.set_id) {
                this.loadTemplateSet(this.$el.dataset.set_id)
                this.switchTemplate(false);
                window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
            } else {
                this.switchTemplate();
            }
        }

        this.undoHistory.push(JSON.stringify(this.components));

        let editorSettings = localStorage.getItem('editorSettings');
        if (editorSettings) {
            this.editorSettings = {...this.editorSettings, ...JSON.parse(editorSettings)};
        }
        this.unlock();
    },
    methods: {
        setAction: function(e) {
            this.action = e.target.name;
        },
        confirmSend: function(e) {
            let ap = this;

            if (!this.confirmed){
                e.preventDefault();
            } else {
                return;
            }

            if (this.action == 'send') {
                if (!this.confirmed){
                    this.$dialog.confirm(
                        'Вы действительно хотите отправить EMAIL рассылку прямо сейчас?',
                        {
                            okText: 'Да, отправить',
                            cancelText: 'Отмена',
                            backdropClose: true,
                        }
                    ).then(
                        function(dialog) {
                            ap.editorActive=false;
                            ap.syncHTML();
                            ap.confirmed=true;
                            setTimeout(function(){
                                ap.$refs.confirmSend.click();
                            }, 1000);
                        }
                    ).catch(
                        function() {
                            ap.confirmed=false;
                        }
                    ); 
                }
            } else if (this.action == 'submit' || this.action == 'test'){
                ap.editorActive=false;
                ap.syncHTML();
                ap.confirmed=true;

                if (this.confirmed){
                    if (this.action == 'test') {
                        setTimeout(function(){
                            ap.$refs.testSchedule.click();
                        }, 1000);
                    } else if (this.action == 'submit'){
                        setTimeout(function(){
                            ap.$refs.saveSchedule.click();
                        }, 1000);
                    }
                }
            }
        },
        confirmSaveTemplateSet: function() {
            let ap = this;
            let exists = false;

            ap.saveTemplateSetDropdown = false;

            ap.templateSets.forEach(function (item, index) {
                if (ap.templateSetName === item.name) {
                    exists = true;
                }
            });

            if (exists) {
                this.$dialog.confirm(
                    'Вариант шаблона с таким именем уже существует, перезаписать?',
                    {
                        okText: 'Да',
                        cancelText: 'Отмена',
                        backdropClose: true,
                    }
                ).then(
                    function(dialog) {
                        ap.saveTemplateSet();
                    }
                ).catch(
                    function() {
                    }
                ); 
            } else {
                ap.saveTemplateSet();
            }
        },
        saveTemplateSet: function() {
            let ap = this;

            if (!this.templateSetName) {
                alert('Имя обязательно')
                return;
            }
            $.ajax({
                type: "POST",
                url: `/template_sets/save/${ap.siteId}/`,
                data: $(this.$refs.templateSetForm).serialize(),
                success: function ( data ) {
                    if (data.errors) {
                        alert( JSON.stringify(data.errors) );
                    } else {
                        $('#flash-container').html(`
                            <div class="flash-messages">
                                <div class="alert alert-info" role="alert"> 
                                    Вариант шаблона сохранен
                                    <button type="button" class="close" data-dismiss="alert">x</button>
                                </div>
                            </div>
                        `);
                        ap.templateSets = data.sets;
                        ap.templateSetChanged = false;
                    }
                },
                error: function(error) {
                    alert('Ошибка при сохранении');
                    return;
                }
            });
        },
        newId: function() {
            this.idCounter++;
            this.templateSetChanged = true
            return this.idCounter
        },
        setTab: function(tabname) {
            this.tab = tabname;
        },
        switchTemplate: function(resetSet = true) {
            let ap = this;
            let templateId = this.template;
            this.lock();

            $.ajax({
                 type: 'GET',
                 url: '/templates/'+templateId+'/',
                 success: function(response) {
                    if (response) {
                        ap.loadTemplate(response);

                        $.ajax({
                             type: 'GET',
                             url: `/template_sets/getlist/${ap.siteId}/${templateId}/`,
                             success: function(data) {
                                if (response) {
                                    if (resetSet){ 
                                        ap.templateSet = ''; 
                                        ap.templateSetName = '';
                                    }
                                    ap.templateSets = data.sets;
                                }
                                ap.unlock();
                            },
                            error: function(error) {
                                alert('Не удалось получить список вариантов для шаблона');
                                return;
                            },
                            always: function() {
                               ap.unlock();
                            }
                        });
                    }
                },
                error: function(error) {
                    alert('Шаблон не найден');
                    return;
                },
                always: function() {
                    ap.unlock();
                }
            });
        },
        switchTemplateSet: function(id, name) {
            let ap = this;
            this.templateSetDropdown = false;

            if (this.templateSetChanged){
                this.$dialog.confirm(
                    'Текущий вариант шаблона был изменен, загрузка варианта приведет к сбросу всех изменений. Продолжить?',
                    {
                        okText: 'Да',
                        cancelText: 'Отмена',
                        backdropClose: true,
                    }
                ).then(
                    function(dialog) {
                        ap.loadTemplateSet(id);
                    }
                ).catch(
                    function() {
                    }
                ); 
            } else {
                ap.loadTemplateSet(id);
            }
        },
        toggleSetDropdown: function() {
            this.templateSetDropdown = !this.templateSetDropdown;
        },
        loadTemplateSet: function(id) {
            let ap = this;

            $.ajax({
                 type: 'GET',
                 url: `/template_sets/get/${ap.siteId}/${id}/`,
                 success: function(response) {
                    if (response) {
                        let data = JSON.parse(response.data);
                        ap.components = data['components'];
                        ap.idCounter = data['idCounter'];
                        ap.templateSetChanged = false;
                        ap.templateSetName = response.name;
                    }
                },
                error: function(error) {
                    alert('Вариант шаблона не найден');
                }
            });
        },
        loadTemplate: function(res) {
            let app = this;
            let allComponents = [];

            delete Vue.options.components['wrapper'];

            this.palette = res.palette;
            this.css = res.css;
            this.applyTemplateStyles(res.css);
            this.emoji = res.emoji;

            let colors = [];
            for (const color of this.$root.palette) {
                colors.push({
                    color: color, 
                    label: color, 
                })
            }
            this.colors = colors;

            for (let component of this.componentsRegistered) {
                delete Vue.options.components[component.name]
            }

            this.componentsRegistered.splice(0, this.componentsRegistered.length);

            let component = null;

            for (let [name, block] of Object.entries(res.blocks)) {
                component = Vue.component(name, {
                    name: name,
                    props: {
                        'data': {
                            'type': Object,
                            'default': null
                        },
                        'tree': {
                            'type': Array,
                            'default': function() { return []} 
                        },
                        'description': {
                            'type': String,
                            'default': null
                        }
                    },
                    mounted: function(){
                        let containers = this.$children.filter(child => { return child.$options._componentTag === 'container' });

                        for (var component of containers) {
                            component.$on('update', this.update);
                            component.$on('remove', this.remove);
                            component.$on('focus', this.focus);
                            component.$on('unfocus', this.unfocus);
                            component.$on('dragstart', this.dragstart);
                            component.$on('dragend', this.dragend);
                        }


                        if (this.data.tree === undefined) {
                            return
                        }
                        
                        if (!this.data.tree.length && containers.length > 0) {
                            let treeContainer = [];
                            if (containers.length > 0) {
                                for(let [index, container] of containers.entries()){
                                    if (block.default && block.default[index]) {
                                        treeContainer.push([...app.incrementIds(block.default[index])]);
                                    } else {
                                        treeContainer.push([]);
                                    }
                                }
                            }
                            this.$root.updateComponent(
                                this.data.id, {'tree': treeContainer}
                            ); 
                        }
                        //if (!this.data.style) {
                            //let setfromdefault = false;
                            //let updateData = {};

                            //if (block.defaultStyles) {
                                //setFromDefault = true;
                                //updateData['style'] = block.defaultStyles;
                            //}
                            //if (block.defaultBgImage) {
                                //setFromDefault = true;
                                //updateData['bgImage'] = block.defaultBgImage;
                            //}

                            //if (setFromDefault) {
                                //this.$root.updateComponent(this.data.id, updateData); 
                            //}
                        //}
                    },
                    methods: {
                        focus: function(id, event) {
                            this.$emit('focus', id, event);
                        },
                        unfocus: function(id, event) {
                            this.$emit('unfocus', id, event);
                        },
                        remove: function(id, event) {
                            this.$emit('remove', id, event);
                        },
                        update: function(id, key, data, event) {
                            this.$emit('update', id, key, data, event);
                        },
                        dragstart: function(id, name, event) {
                            this.$emit('dragstart', id, name, event);
                        },
                        dragend: function(event) {
                            this.$emit('dragend', event);
                        },
                    },
                    template: block.template,
                    description: block.description,
                    styles: block.styles,
                });
                Vue.use(name, component);
                this.componentsRegistered.push({
                    type: name,
                    registered: true,
                    description: block.description,
                    styles: block.styles,
                    style: block.defaultStyles || {},
                    bgImage: block.defaultBgImage || null,
                    icon: block.icon
                });
                this.syncHTML();
            }

            allComponents = this.componentsAvailable.map(
                function(el) { return el.type; }
            );

            allComponents = allComponents.concat(
                this.componentsRegistered.map(
                    function(el) {return el.type }
                )
            )

            for (let component of this.components) {
                component.registered = allComponents.includes(component.type);
            }

            component = Vue.component('wrapper', {
                name: 'Wrapper',
                template: res.wrapper,
            });
            Vue.use('wrapper', component);


            //this forces rerender, as we do not modify components here
            this.idCounter++;
        },
        applyTemplateStyles: function() {
            //clear old rules
            for (var i=this.styleWriter.sheet.cssRules.length-1; i > 0; i--) {
                this.styleWriter.sheet.deleteRule(i);
            }  
            var doc = document.implementation.createHTMLDocument("");
            var styleWriter = document.createElement("style");

            styleWriter.textContent = this.css;
            doc.body.appendChild(styleWriter);

            for (let rule of styleWriter.sheet.cssRules) {
                this.styleWriter.sheet.insertRule('#preview '+ rule.cssText.replace('body', ''), this.styleWriter.sheet.cssRules.length);
            }
        },
        clone: function(item) {
            let cloned = {
                id: this.newId(),
                type: item.type,
                registered: true,
                description: item.description,
                styles: item.styles || [],
                style: item.style || {},
                bgImage: item.bgImage || null,
                tree: [],
            };

            if (item.type === 'image') {
                Object.assign(cloned, {
                    image: null,
                    href: null,
                })
            }

            if (item.type === 'columns') {
                Object.assign(cloned, {
                    columns: [33.3333333, 33.33333, 33.33333],
                    tree: [[], [], [], [], []]
                })
            }

            if (item.type === 'editable') {
                Object.assign(cloned, {
                    content: '',
                })
            }

            return cloned; 
        },
        onMove: function(evt, originalEvent){
            const supports = evt.to.__vue__.$parent.$parent.supports;


            //$(evt.relatedContext.component.$el).addClass('expand');

            if (supports.length == 0) {
                return true;
            }

            if (!supports.includes(evt.draggedContext.element.type)) {
                return false;
            }
        },
        onEnd: function(evt, originalEvent){
            window.mouseBtnPressed = false;
            window.dragActive = false;
            this.draggedType = null;
            this.draggedId = null;

            if (this.undoIndex < this.undoHistory.length-1) {
                this.undoHistory.splice(0, this.undoIndex);
            }
            this.syncUndoBuffer();
            this.syncHTML();
        },
        updateComponent: function(id, data, action='update') {
            for (const [i, element] of this.components.entries()) {
                if (element.id == id) {
                    if (action === 'update') {
                        for (let [key, value] of Object.entries(data)) {
                            if (JSON.stringify(value) !== JSON.stringify(this.components[i][key])) {
                                this.componentChanged = true;
                                break;
                            }
                        }
                        this.components[i] = Object.assign(this.components[i], data);
                        Vue.set(this.components, i, this.components[i]);
                    } else if (action === 'remove') {
                        this.components.splice(i, 1);
                        this.editorActive = false;
                        this.componentChanged = true;
                        this.syncUndoBuffer();
                    } else if (action === 'duplicate') {
                        this.components.splice(i+1, 0, this.incrementIds(data));
                        this.componentChanged = true;
                        this.syncUndoBuffer();
                    }
                    if (this.undoIndex < this.undoHistory.length-1) {
                        this.undoHistory.splice(0, this.undoIndex);
                    }
                    this.syncHTML();
                    return
                }
                this.updateBranch(element.tree, id, data, i, action);
            }
        },
        updateBranch: function(branch, id, data, elemId, action){
            for (const [i, children] of branch.entries()) {
                for (const [k, child] of children.entries()) {
                    if (child.id == id) {
                        if (action === 'update') {
                            for (let [key, value] of Object.entries(data)) {
                                if (JSON.stringify(value) !== JSON.stringify(branch[i][k][key])) {
                                    this.componentChanged = true;
                                    break;
                                }
                            }
                            branch[i].splice(k, 1, Object.assign(branch[i][k], data));
                            Vue.set(this.components, elemId, this.components[elemId]);
                        } else if (action === 'remove'){
                            branch[i].splice(k, 1);
                            this.editorActive = false;
                            this.componentChanged = true;
                            this.syncUndoBuffer();
                        } else if (action === 'duplicate') {
                            branch[i].splice(k+1, 0, {...this.incrementIds(data), id: this.newId()});
                            this.componentChanged = true;
                            this.syncUndoBuffer();
                        }
                        if (this.undoIndex < this.undoHistory.length-1) {
                            this.undoHistory.splice(0, this.undoIndex);
                        }
                        this.syncHTML();
                        return true;
                    } else {
                        this.updateBranch(child.tree, id, data, elemId, action);
                    }
                }
            }
            return false;
        },
        removeComponent: function(id) {
            this.updateComponent(id, null, 'remove');
        },
        duplicateComponent: function(id, data) {
            this.updateComponent(id, data, 'duplicate');
        },
        incrementIds: function(data){
            let app = this;
            let duplicate = JSON.parse(
                JSON.stringify(
                    data,
                    function(key, value) {
                        if (value !== null && key === 'id') {
                            return app.newId(value);
                        } else {
                            return value;
                        }
                    }
                )
            );
            return duplicate;
        },
        undo: function() {
            if (this.undoIndex > 0) {
                this.undoIndex -= 1;
                this.components = JSON.parse(this.undoHistory[this.undoIndex]);
            }
        },
        redo: function() {
            if (this.undoIndex < this.undoHistory.length-1) {
                this.undoIndex += 1;
                this.components = JSON.parse(this.undoHistory[this.undoIndex]);
            }
        },
        lock: function() {
            this.locked = true;
        },
        unlock: function() {
            this.locked = false;
        },
        toggleLock: function(state) {
            this.locked = state;
        },
        focusComponent: function(id) {
            for (let [componentId, component] of Object.entries(this.componentRefs)) {
                if (componentId != id ) {
                    component.highlightOff();
                }
            }
            this.editorActive = id;
        },
        unfocusComponent: function(id) {
            this.editorActive = false;
            if (this.componentChanged) { 
                this.syncUndoBuffer();
            }
        },
        syncUndoBuffer: function() {
            if (this.undoHistory.length >= 20) {
                this.undoHistory.shift();
            }
            this.undoHistory.push(JSON.stringify(this.components));
            this.undoIndex = this.undoHistory.length-1; 
            this.templateSetChanged = true
            this.componentChanged = false;
        },
        dragStart: function(id, name, event) {
            this.draggedType = name;
            this.draggedId = id;
            return event;
        },
        dragEnd: function(event) {
            this.draggedType = null;
            this.draggedId = null;
            return event;
        },
        syncHTML: function () { 
            if (JSON.stringify(this.components).includes('{@ unsubscribe @}')) {
                this.hasUnsubscribe = true;
            } else {
                this.hasUnsubscribe = false;
            }

            this.$nextTick(function () {
                if (this.$refs.templateHTML) {
                    this.html = this.$refs.templateHTML.outerHTML;
                }
            })
        },
    }
}
</script>
